/**
 * Stages & Methodology Interactive Highlighting
 */
(function() {
  'use strict';

  function initStages() {
    const stageCards = document.querySelectorAll('.stage-card');
    if (!stageCards.length) return;

    stageCards.forEach(function(card) {
      card.addEventListener('mouseenter', function() {
        stageCards.forEach(function(c) {
          if (c !== card) c.style.opacity = '0.7';
        });
      });

      card.addEventListener('mouseleave', function() {
        stageCards.forEach(function(c) {
          c.style.opacity = '1';
        });
      });
    });
  }

  window.GinaStages = { init: initStages };
})();
